import { createContentContext } from "./createContentContext";

// Usar factory para crear el contexto de Software Engineering
// Reemplaza la implementación duplicada con la factory reutilizable
const { Context, Provider } = createContentContext(
  "pages-software-engineering",
  "Software Engineering"
);

export const ContentSEContext = Context;
export const ContentSEProvider = Provider;
